import api from "@/api";
export default class RepairStatus {
  constructor(_default) {
    if (_default !== undefined) {
      this._default = _default;
      for (let prop in _default) {
        this[prop] = _default[prop];
      }
    }
  }

  static async list(params) {
    const res = await api.get(`/api/v1/repair/status/`, params);
    if (res) return res.data;
    return null;
  }

  static async store(payload) {
    const res = await api.post(`/api/v1/repair/create/status/`, payload);
    if (res) return res.data.data;
    return null;
  }

  static async update(payload) {
    const res = await api.put(
      `/api/v1/repair/update/status/${payload.id}/`,
      payload
    );
    if (res) return res.data.data;
    return null;
  }
}
